var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-too-big"},[_c('icon-base',{attrs:{"viewBox":"0 0 24 24","width":"16","height":"16"}},[_c('IconAttention')],1),_c('div',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('area_too_big_gras')))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('area_too_big_suite')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }